export default __webpack_public_path__ + "static/book-598fa869f22d52781c5f86bbcd558109.svg";